import { TIN_RE } from "./reference.js";

const clean = (value) => (typeof value === "string" ? value.trim() : "");

export function invoiceParty(value) {
  return {
    name: clean(value?.name),
    tin: clean(value?.tin),
    address: clean(value?.address),
  };
}

export function invoiceParties(invoice) {
  return {
    seller: invoiceParty(invoice?.seller),
    buyer: invoiceParty(invoice?.buyer),
  };
}

export function invoicePartyError(value, label = "Client") {
  const party = invoiceParty(value);
  if (!party.name) return `${label} registered name is required.`;
  if (!TIN_RE.test(party.tin))
    return `${label} needs a valid TIN in 000-000-000-00000 format.`;
  if (!party.address) return `${label} business address is required.`;
  return "";
}

export function invoiceIdentityError(invoice) {
  return (
    invoicePartyError(invoice?.seller, "Seller") ||
    invoicePartyError(invoice?.buyer, "Buyer")
  );
}

export function invoiceImportError(state) {
  if (!Array.isArray(state?.clients) || !Array.isArray(state?.invoices))
    return "The workspace export must include clients and invoices.";
  for (const [index, client] of state.clients.entries()) {
    const error = invoicePartyError(
      client,
      `Client ${client?.id || index + 1}`,
    );
    if (error) return error;
  }
  for (const [index, invoice] of state.invoices.entries()) {
    const error = invoiceIdentityError(invoice);
    if (error) return `Invoice ${invoice?.no || index + 1}: ${error}`;
  }
  return "";
}

export function invTotals(net, retPct) {
  const vat = Math.round(net * 0.12),
    gross = net + vat,
    ret = Math.round((gross * retPct) / 100);
  return { net, vat, gross, ret, due: gross - ret };
}
